<div
  class="popup"
  [class]="popupPosition"
  [ngClass]="{
    popupSlider: sliderWrapper
  }"
  [style.--widthChild.px]="widthChild"
  [style.--left.px]="'-' + (widthChild + 10)"
  [style.--leftFixed.px]="leftCoordinate - (widthChild + 10)"
  [style.--topFixed.px]="topCoordinate - 10"
  (mouseleave)="mouseEvent(false)"
  (mouseenter)="mouseEvent(true)"
  (touchend)="touchEvent()"
>
  <div class="popup__wrap">
    <div class="popup__close" (click)="closePopup('0')">&#10006;</div>
    <div class="popup__triangle">
      <span class="triangle__top"></span>
      <span class="triangle__bottom"></span>
    </div>
    <div class="popup__content">
      <ng-content></ng-content>
    </div>
  </div>
  <div class="popup__overlay"></div>
</div>
